export default __webpack_public_path__ + "static/media/logo-fare.d0f4ad25.svg";